import type { SimpleSelectOption } from "@/shared/ui/SimpleSelect";

export const statusLabels: Record<string, string> = {
  active: "ໃຊ້ງານ",
  draft: "ປັບປຸງ",
  inactive: "ເລີກໃຊ້",
};

export const statusColors: Record<
  string,
  "default" | "secondary" | "outline" | "destructive"
> = {
  active: "default",
  draft: "secondary",
  inactive: "destructive",
};

export const statusOptions: SimpleSelectOption[] = [
  { value: "active", label: "ໃຊ້ງານ" },
  { value: "draft", label: "ປັບປຸງ" },
  { value: "inactive", label: "ເລີກໃຊ້" },
];
